import updateSelfPresence from './updateSelfPresence';
import signIn from '../services/signIn';
import { getStore } from '../store/presenceStore';
import ChatSignInState from '../store/schema/ChatSignInState';
import InstantMessageOperationError from '../store/schema/InstantMessageOperationError';
import { logUsage } from 'owa-analytics';
import {
    changeSignInState,
    setIsRetrySignInAllowed,
    setProcessingManualSignIn,
} from '../actions/presenceActions';
import setServiceAvailability, {
    setServiceNotAvailableIfTimeout,
    clearSetServiceNotAvailableTimer,
} from './setServiceAvailability';

const SIGN_IN_RETRY_IN_MILLISECONDS = 30 * 1000;

export const enum SignInType {
    Manual,
    Auto,
    Retry,
}

export default function signInIM(signInType: SignInType): boolean {
    const signInFunction = internalSignIn(signInType);
    if (signInType == SignInType.Retry) {
        if (getStore().isRetrySignInAllowed) {
            window.setTimeout(signInFunction, SIGN_IN_RETRY_IN_MILLISECONDS);

            setIsRetrySignInAllowed(false /*isAllowed*/);
            return true;
        } else {
            return false;
        }
    } else {
        setProcessingManualSignIn(signInType == SignInType.Manual);
        signInFunction();
        return true;
    }
}

const internalSignIn = (signInType: SignInType) => () => {
    changeSignInState(ChatSignInState.AttemptingSignIn);
    clearSetServiceNotAvailableTimer();
    logUsage('UcmaSkypeSignInAttempted', [signInType]);

    signIn(getStore().processingManualSignIn)
        .then(result => {
            switch (result as InstantMessageOperationError) {
                case InstantMessageOperationError.Success:
                    changeSignInState(ChatSignInState.SignedIn);
                    setServiceNotAvailableIfTimeout();
                    updateSelfPresence('Online');
                    break;

                case InstantMessageOperationError.NotSignedIn:
                    // This indicates that an automatic sign-in (e.g. pressing F5)
                    // failed because the user explicitly signed out.
                    changeSignInState(ChatSignInState.SignedOut);
                    setServiceAvailability(false /*signedIn*/);
                    updateSelfPresence('Offline');
                    break;

                default:
                    setServiceAvailability(false /*signedIn*/);
                    updateSelfPresence('Offline');
                    break;
            }
            logUsage('UcmaSkypeSignInService', [result]);
        })
        .catch(() => {
            setServiceAvailability(false /*signedIn*/);
            updateSelfPresence('Offline');
            logUsage('UcmaSkypeSignInServiceError');
        });
};
